import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);

import '../cube-ui'
import store from '@/store'
import wx from 'weixin-js-sdk'

export function Message (str) {
  return this.$createToast({
    txt: str,
    type: 'error'
  }).show()
}

export function result(row) {
  var result = [];
  for(var i=0;i<row.length;i+=3){
    result.push(row.slice(i,i+3));
  }
  console.log('原始数据',row)
  console.log('组合后的数据',result)
  return result
}

//对象转formdata格式
export function jsToFormData(config) { 
  const formData = new FormData();
  //循环传入的值转换formData
  Object.keys(config).forEach((key) => {
    formData.append(key, config[key]);
  })
  return formData;
}

//formdata转对象格式
export function jsonData(formData){
  var jsonData = {};
  formData.forEach((value, key) => jsonData[key] = value);
  return jsonData
}

// 日期转换时分
export function formatTime(result) {
  let date = new Date(result);
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return hour + '时' + minute + '分'
}

// 直播时间，直播倒计时
export function disposeTime(oldtime){
  let date1 = new Date(oldtime)
  let s2= Date.parse(new Date());
  let s1 = date1.getTime()
  let total = (s2 - s1)/1000;
  let day = parseInt(total / (24*60*60));//计算整数天数
  let afterDay = total - day*24*60*60;//取得算出来天数后剩余的秒数
  let hour = parseInt(afterDay/(60*60));//计算整数小时百数
  hour = hour<10?'0'+hour:hour
  let afterHour = total - day*24*60*60 - hour*60*60;//取得算出小时数后剩余的秒数
  let min = parseInt(afterHour/60);//计算整数分
  min = min<10?'0'+min:min
  let afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后度剩余的秒数
  return hour !==0 ? hour + '时' + min + '分' : min + '分'
}
export function disposeTime1(oldtime){
  let date1 = new Date(oldtime)
  let s2= Date.parse(new Date());
  let s1 = date1.getTime()
  let total = (s1 - s2)/1000;
  let day = parseInt(total / (24*60*60));//计算整数天数
  let afterDay = total - day*24*60*60;//取得算出来天数后剩余的秒数
  let hour = parseInt(afterDay/(60*60));//计算整数小时百数
  hour = hour<10?'0'+hour:hour
  let afterHour = total - day*24*60*60 - hour*60*60;//取得算出小时数后剩余的秒数
  let min = parseInt(afterHour/60);//计算整数分
  min = min<10?'0'+min:min
  let afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后度剩余的秒数
  console.log('day',day)
  return day!==0 ? day + '天' + hour + '时' + min + '分' : hour!==0 ? hour + '时' + min + '分' : min + '分'
}

// 秒转换时分
export function secondToDate(result) {
  var h = Math.floor(result / 3600) < 10 ? '0'+Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  // return result = h + ":" + m + ":" + s;
  return result = h + "小时" + m + "分";
}

// 获取从业年数
export function getDateYear(year) {
  let yearDate = year == '' ? 0 : year
  console.log('year=',yearDate);
  let a = new Date().getFullYear();
  let b = year;
  let num;
  var arrA = a.toString().split("-");
  var arrB = b.toString().split("-");
  if (yearDate === '请选择' || yearDate === 0) {
    num = '小于1'
  } else {
    if(arrA[1]<arrB[1]||arrA[2]<arrB[2]){
      num = arrA[0] - arrB[0]-1;
    }else{
      num = arrA[0] - arrB[0];
    }
  }
  // console.log('year=',num);
  return num;
}

// 种类数组匹配返回数组
export function classType(arr) {
  var arrList = []
  var classStr = {
    "JCDX01":"猪",
    "JCDX02":"鸡",
    "JCDX03":"鸭",
    "JCDX04":"鹅",
    "JCDX05":"牛",
    "JCDX06":"马",
    "JCDX07":"羊",
    "JCDX08":"兔",
    "JCDX09":"犬",
    "JCDX10":"猫",
    "JCDX11":"鸽",
    "JCDX12":"鱼",
    // "JCDX13":"畜禽饮用水",
    "JCDX14":"饲料",
    // "JCDX15":"动物源性产品",
    "JCDX16":"兽药",
    "JCDX17":"水貂",
    // "JCDX18":"研发服务",
    "JCDX19":"疫苗",
    // "JCDX20":"动物实验小鼠",
    // "JCDX21":"消毒剂",
    "JCDX22":"水"
  }
  // for (let i=0; i<arr.length; i++) {
  //   console.log('dddd=',classStr)
  //   for (let key in classStr) {
  //     if (key == arr[i]) {
  //       console.log('222',classStr[key])
  //       arrList.push(classStr[key])
  //     }
  //   }
  // }
  arr.forEach((item,i) => {
    for (let key in classStr) {
      if (key == item) {
        arrList.push(classStr[key])
      }
    }
  })
  // console.log('arrList=',arrList)
  return arrList
}

// 数组去重
export function unique(arr) {
  console.log('arr',arr)
  const res = new Map();
  return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
}
export function unique1(arr) {
  console.log('arr',arr)
  const res = new Map();
  return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
}

// 判断是否是微信浏览器
export function iswx() {
  var ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else {
    return false;
  }
}

// 搜索关键字文本高亮
export function searchHighlight(val) {
  let contentlist = document.querySelectorAll(".content");
  // console.log('val=',val);
  let str = ''
  let str1 = ''
  let value = val
  let reg = new RegExp(val,'g')
  let strreg = '<strong>' + val + "</strong>"
  if (value && value.length > 0) {
    if (contentlist.length > 0) {
      for (let i = 0; i < contentlist.length; i++) {
        contentlist[i].innerHTML = contentlist[i].innerHTML.replace(/<strong>([^<]*?)<\/strong>/gi, '$1')
        str = contentlist[i].innerHTML.replace(reg,strreg)
        contentlist[i].innerHTML = str
        // console.log('str=',str);
      }
    } else {
      Toast('请最少打开一个折叠面板')
    }
  } else {
    Toast('请输入关键字')
  }
}

// 微信分享
export async function wxshare(imgurl,title,desc,url) {
  const { data } = await store.dispatch('report/wxshare')
  // console.log('data=',data)
  var shareUrl1 = ''
  if (url) {
    shareUrl1 = url;
  } else {
    shareUrl1 = window.location.href;
  }
  // console.log('shareUrl1',shareUrl1)
  // var shareUrl1 = window.location.href;
  var img = imgurl;
  var name = title;
  var descstr = desc;
  var appId = data.wechat_app_id;
  var timestamp = data.timestamp;
  var nonceStr = data.noncestr;
  var signature = data.signature;
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature,// 必填，签名，见附录1
    jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-app']
  });
  wx.ready(function(){
    let imgurl = img;
    let title = name;
    let desc = descstr;
    wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
        // alert("errorMSG:"+res.errMsg);
    });
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: shareUrl1, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        this.$createToast({
          type: 'correct',
          txt: '分享成功',
          time: 1000
        }).show()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
        this.$createToast({
          txt: '分享失败',
          type: 'error'
        }).show()
      }
    });
    wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl1, // 分享链接
        imgUrl: imgurl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
          this.$createToast({
            type: 'correct',
            txt: '分享成功',
            time: 1000
          }).show()
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          this.$createToast({
            txt: '分享失败',
            type: 'error'
          }).show()
        }
    });
  });
}

// 微信分享
export async function wxsharetest(imgurl,title,desc,url) {
  const { data } = await store.dispatch('report/wxshare')
  // console.log('data=',data)
  var shareUrl1 = ''
  if (url) {
    shareUrl1 = url;
  } else {
    shareUrl1 = window.location.href;
  }
  console.log('shareUrl1',shareUrl1)
  // var shareUrl1 = window.location.href;
  var img = imgurl;
  var name = title;
  var descstr = desc;
  var appId = data.wechat_app_id;
  var timestamp = data.timestamp;
  var nonceStr = data.noncestr;
  var signature = data.signature;
  console.log('img',img)
  console.log('name',name)
  console.log('descstr',descstr)
  console.log('appId',appId)
  console.log('timestamp',timestamp)
  console.log('nonceStr',nonceStr)
  console.log('signature',signature)
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature,// 必填，签名，见附录1
    jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-app']
  });
  wx.ready(function(){
    let imgurl = img;
    let title = name;
    let desc = descstr;
    wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
        // alert("errorMSG:"+res.errMsg);
    });
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: shareUrl1, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        this.$createToast({
          type: 'correct',
          txt: '分享成功',
          time: 1000
        }).show()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
        this.$createToast({
          txt: '分享失败',
          type: 'error'
        }).show()
      }
    });
    wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl1, // 分享链接
        imgUrl: imgurl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
          this.$createToast({
            type: 'correct',
            txt: '分享成功',
            time: 1000
          }).show()
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          this.$createToast({
            txt: '分享失败',
            type: 'error'
          }).show()
        }
    });
  });
}